import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Box,
  CircularProgress,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import { loadTags, createTag, updateTag, deleteTag } from '../../services/api';
import LaunchIcon from '@mui/icons-material/Launch';
import { TwitterPicker } from 'react-color';

export default function Index({ userStore }) {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingTag, setEditingTag] = useState(null);
  const [tagName, setTagName] = useState('');
  const [tagColor, setTagColor] = useState('#3f51b5');
  const [isCreating, setIsCreating] = useState(false);

  useEffect(() => {
    const fetchTagsData = async () => {
      try {
        setLoading(true);
        const response = await loadTags(userStore.token);
        setTags(response.data.data);
        setError(null);
      } catch (err) {
        console.error('Erro ao carregar tags:', err);
        setError('Não foi possível carregar as tags. Tente novamente mais tarde.');
      } finally {
        setLoading(false);
      }
    };

    fetchTagsData();
  }, [userStore.token]);

  if (loading) {
    return (
      <Box display='flex' justifyContent='center' p={3}>
        <CircularProgress />
      </Box>
    );
  }

  const handleOpenCreateDialog = () => {
    setIsCreating(true);
    setEditingTag(null);
    setTagName('');
    setTagColor('#3f51b5');
  };

  const handleTagClick = (tag) => {
    setIsCreating(false);
    setEditingTag(tag);
    setTagName(tag.name);
    setTagColor(tag.color);
  };

  const handleCloseDialog = () => {
    setEditingTag(null);
    setTagName('');
    setTagColor('#3f51b5');
    setIsCreating(false);
  };

  const handleSave = async () => {
    try {
      if (isCreating) {
        // Criar nova tag
        const response = await createTag(userStore.token, {
          name: tagName,
          color: tagColor
        });
        setTags([...tags, response.data.data]);
      } else {
        // Atualizar tag existente
        await updateTag(userStore.token, editingTag.id, {
          name: tagName,
          color: tagColor
        });
        // Atualiza a lista de tags
        const updatedTags = tags.map(tag =>
          tag.id === editingTag.id ? { ...tag, name: tagName, color: tagColor } : tag
        );
        setTags(updatedTags);
      }
      handleCloseDialog();
    } catch (err) {
      const action = isCreating ? 'criar' : 'atualizar';
      console.error(`Erro ao ${action} tag:`, err);
      setError(`Erro ao ${action} a tag. Tente novamente.`);
    }
  };

  const handleDelete = async () => {
    if (window.confirm('Tem certeza que deseja excluir esta tag?')) {
      try {
        await deleteTag(userStore.token, editingTag.id);
        const updatedTags = tags.filter(tag => tag.id !== editingTag.id);
        setTags(updatedTags);
        handleCloseDialog();
      } catch (err) {
        console.error('Erro ao excluir tag:', err);
        setError('Erro ao excluir a tag. Tente novamente.');
      }
    }
  };

  return (
    <>
      <Card>
        <CardContent>
          <Box display='flex' flexWrap='wrap' gap={1}>
            <Chip icon={<AddIcon />} label='Nova Tag' onClick={handleOpenCreateDialog} />
            {tags?.map((tag) => (
              <Chip
                icon={<LaunchIcon style={{ color: 'white' }} fontSize='small' />}
                key={tag.id}
                label={tag.name}
                onClick={() => handleTagClick(tag)}
                style={{
                  backgroundColor: tag.color,
                  color: 'white',
                  margin: '2px',
                  cursor: 'pointer',
                  '&:hover': {
                    opacity: 0.9
                  }
                }}
              />
            ))}
          </Box>
        </CardContent>
      </Card>

      <Dialog open={!!editingTag || isCreating} onClose={handleCloseDialog} maxWidth='sm' fullWidth>
        <DialogTitle>{isCreating ? 'Nova Tag' : 'Editar Tag'}</DialogTitle>
        <DialogContent>
          <Box mt={2}>
            <TextField
              label='Nome da Tag'
              fullWidth
              value={tagName}
              onChange={(e) => setTagName(e.target.value)}
              margin='normal'
              variant='outlined'
            />
            <Box mt={2}>
                <TwitterPicker color={tagColor} onChangeComplete={(color) => setTagColor(color.hex)} triangle='hide' />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box display='flex' justifyContent='space-between' width='100%' px={2} py={1}>
            <Box>
              {!isCreating && (
                <Button
                  onClick={handleDelete}
                  color='error'>
                  Excluir Tag
                </Button>
              )}
            </Box>
            <Box>
              <Button onClick={handleCloseDialog} color='primary' style={{ marginLeft: 8 }} >
                Cancelar
              </Button>
              <Button
                onClick={handleSave}
                color='primary'
                variant='contained'
                style={{ marginLeft: 8 }}
                disabled={!tagName.trim()}
              >
                {isCreating ? 'Criar' : 'Salvar'}
              </Button>
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
}
